import { useNavigate } from 'react-router-dom';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function MaintenancePage({ onRetry }) {
  const navigate = useNavigate();

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-slate-100">
          <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <AlertTriangle className="w-10 h-10 text-orange-600" />
          </div>
          
          <h1 className="text-2xl font-bold text-slate-900 mb-3">
            Service Temporarily Unavailable
          </h1>
          <p className="text-slate-600 mb-6">
            We're experiencing technical difficulties. Please try again in a moment.
          </p>

          <div className="space-y-3">
            <Button
              onClick={handleRetry}
              className="w-full bg-green-600 hover:bg-green-700"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Retry Connection
            </Button>
            
            <Button
              variant="outline"
              onClick={() => navigate('/')}
              className="w-full"
            >
              Go to Homepage
            </Button>
          </div>

          <p className="text-sm text-slate-500 mt-6">
            If the problem persists, please contact support.
          </p>
        </div>
      </div>
    </div>
  );
}
